import { useState, useEffect } from 'react';
import { userMedia } from 'utils';
import { permissionTypes } from 'const';

export default () => {
  const [microphonePermission, setMicrophonePermission] = useState(null);
  const [cameraPermission, setCameraPermission] = useState(null);

  useEffect(async () => {
    if (navigator?.permissions?.query) {
      try {
        let micPermissionStatus = await navigator.permissions.query({ name: 'microphone' });
        setMicrophonePermission(micPermissionStatus.state); // granted, denied, prompt

        if (micPermissionStatus.state !== permissionTypes.granted) {
          try {
            await userMedia({ audio: true });
            micPermissionStatus = await navigator.permissions.query({ name: 'microphone' });
            setMicrophonePermission(micPermissionStatus.state);
          } catch (err) {
            setMicrophonePermission(permissionTypes.denied);
          }
        }
        // eslint-disable-next-line func-names
        micPermissionStatus.onchange = function () {
          setMicrophonePermission(this.state);
        };
      } catch (err) {
        setMicrophonePermission(permissionTypes.denied);
      }
    } else {
      try {
        await userMedia({ audio: true });
        setMicrophonePermission(permissionTypes.granted);
      } catch (err) {
        setCameraPermission(permissionTypes.denied);
      }
    }
  }, []);

  useEffect(async () => {
    if (navigator?.permissions?.query) {
      try {
        let camPermissionStatus = await navigator.permissions.query({ name: 'camera' });
        setCameraPermission(camPermissionStatus.state);
        if (camPermissionStatus.state !== permissionTypes.granted) {
          try {
            await userMedia({ video: true });
            camPermissionStatus = await navigator.permissions.query({ name: 'camera' });
            setCameraPermission(camPermissionStatus.state);
          } catch (err) {
            setCameraPermission(permissionTypes.denied);
          }
        }
        // eslint-disable-next-line func-names
        camPermissionStatus.onchange = function () {
          setCameraPermission(this.state);
        };
      } catch (err) {
        setCameraPermission(permissionTypes.denied);
      }
    } else {
      try {
        await userMedia({ video: true });
        setMicrophonePermission(permissionTypes.granted);
      } catch (err) {
        setCameraPermission(permissionTypes.denied);
      }
    }
  }, []);
  return { microphonePermission, cameraPermission };
};
